import React from 'react';
import { Card } from "react-bootstrap";
import face_laszlo_csato from "../../assets/img/3.png";
import ShowMoreText from "react-show-more-text";
import proj_fairness_of_swiss_system from "../../assets/img/proj_fairness_of_swiss_system.png";

const Laszlo_Csato_swiss_system = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_fairness_of_swiss_system} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_laszlo_csato}
              /* this will be the text on the banner */
              alt="The fairness of Swiss-system tournaments"
            />{" "}
            <p className="text7">László Csató</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            <p className="text8">Research Group of Operations Research and Decision Systems, SZTAKI </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Swiss-system tournament is a non-eliminating tournament format where a large number 
            of competitors play a relatively small number of rounds. It is used in many sports 
            such as chess and e-sports. In contrast to round-robin tournaments, ranking in a 
            Swiss-system tournaments is far from trivial because of the varying strength of 
            opponents for each player. This project aims to empirically test some potential 
            problems of fairness in the ranking of Swiss-system tournaments.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                Csató, L. (2017). On the ranking of a Swiss system chess team tournament. Annals of Operations Research, 254(1), 17-36.
                </li>
                <li>
                Dong, Z. L., Ribeiro, C. C., Xu, F., Zamora, A., Ma, Y., & Jing, K. (2023). Dynamic scheduling of 
                e-sports tournaments. Transportation Research Part E: Logistics and Transportation Review, 169, 102988.
                </li>
                <li>
                Sauer, P., Cseh, Á., & Lenzner, P. (2024). Improving ranking quality and fairness in Swiss-system 
                chess tournaments. Journal of Quantitative Analysis in Sports, 20(2), 127-146.
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Laszlo_Csato_swiss_system;